<template>
	<div >
		<div class="app-container">
			<el-descriptions title="质检检验检测报告" :column="2" border>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					受检单位
					</template>
					 {{zjjcxx.sjdw}}
				</el-descriptions-item>				
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	生产单位
				 	</template>
				 	 {{zjjcxx.scdw}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					产品名称
					</template>
					 {{zjjcxx.ypmc}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					检验日期
					</template>
					 {{zjjcxx.jyrq}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					报告编号
					</template>
					 {{zjjcxx.bgbh}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					委托单位
					</template>
					 {{zjjcxx.wtdw}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					检验类别
					</template>
					 {{zjjcxx.jylb}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					规格型号
					</template>
					 {{zjjcxx.ypgg}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					任务来源
					</template>
					 {{zjjcxx.rwly}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					抽样日期
					</template>
					 {{zjjcxx.cyrq}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					抽样基数
					</template>
					 {{zjjcxx.cyjs}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					生产日期/批号
					</template>
					 {{zjjcxx.scrq}}
				</el-descriptions-item>			 
				<el-descriptions-item labelStyle="width:120px" span=2>
					<template slot="label" >						 
					检验结论
					</template>
					 {{zjjcxx.jyjl}}
				</el-descriptions-item>
			</el-descriptions>
			 
		</div>
	</div>
</template>

<script> 
	export default {
		name: 'Zjjcxx',
		props: {
			//质检检验检测报告
			zjjcxx: {
				type: Object,
				require: true
			}
		},
		watch: {
			zjjcxx(newValue, oldValue) {
				//this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				 
			}
		},
		created() {
			//this.init();
			 
		},
		methods: {
			 
		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
